export const ENI = 'ENI';
export const IP = 'IP';
export const Q8 = 'Q8';
export const ESSO = 'ESSO';
export const COLOR_WITHOUT_RA = 'default';
export const COLOR_TO_BE_ANALYZED = 'secondary';
export const COLOR_RA_BILLABLE = 'warning';
export const COLOR_RA_BILLED = 'success';
export const COLOR_ERROR = 'error';
export const COLOR_IMPORTED = 'success';
export const COLOR_REJECTED = 'error';
export const WITHOUT_RA = "WITHOUT_RA";
export const TO_BE_ANALYZED = "TO_BE_ANALYZED";
export const RA_TO_BE_INVOICED = "RA_TO_BE_INVOICED";
export const RA_BILLED = "RA_BILLED";
export const REJECTED = "REJECTED";
export const PROCESSING = "PROCESSING";
export const IMPORTED = "IMPORTED";
export const ERROR = "ERROR";

export const NOT_DEFINED = "NOT_DEFINED";
export const RENTAL = "RENTAL";
export const NEW_CAR = "NEW_CAR";
export const PROMISCUOUS = "PROMISCUOUS";
export const CAR_SERVICE = "CAR_SERVICE";

export const ACTIVE = "ACTIVE";
export const EXPIRED = "EXPIRED";
export const BLOCKED = "BLOCKED";
export const SUSPENDED = "SUSPENDED";

export const COLOR_ACTIVE = "success";
export const COLOR_EXPIRED = "secondary";
export const COLOR_BLOCKED = "error";
export const COLOR_SUSPENDED = "warning";

export const SHARING = "SHARING";
export const SHORT_TERM = "SHORT_TERM";
export const LONG_TERM = "LONG_TERM";

export const AMOUNT_REG_EXP =  /^\s*-?[0-9]\d*(\.\d{0,2})?\s*$/
export const DECIMAL_6_DIGITS =  /^\d{6}/
export const DECIMAL_9_DIGITS =  /^\d{9}/

export const fcReportFilterdefaultValues = {
    supplier: [] as Array<string>,
    importDateFrom: null,
    importDateTo: null,
    fileName: '',
    importedBy: '',
    totalRefuellingFrom: "",
    totalRefuellingTo: ""
}


